// src/utils/geolocateCity.js

export async function geolocateCity() {
    return new Promise((resolve, reject) => {
        if (!navigator.geolocation) {
            reject({ code: "UNSUPPORTED" });
            return;
        }

        navigator.geolocation.getCurrentPosition(
            async (pos) => {
                try {
                    const { latitude, longitude } = pos.coords;
                    const url = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`;

                    const res = await fetch(url, {
                        headers: { "User-Agent": "ALCWash/1.0 (email@tuo.it)" },
                    });

                    if (!res.ok) {
                        reject({ code: "REVERSE_FAIL" });
                        return;
                    }

                    const data = await res.json();
                    const city =
                        data?.address?.city ||
                        data?.address?.town ||
                        data?.address?.village ||
                        "";

                    if (!city) {
                        reject({ code: "NO_CITY" });
                        return;
                    }

                    resolve(city);
                } catch (error) {
                    reject({ code: "UNKNOWN", error });
                }
            },
            () => {
                // rifiutato o errore di permesso
                reject({ code: "DENIED" });
            }
        );
    });
}
